module.exports = __webpack_public_path__ + "images/canonical-card/bouncer-taco.66240b4e7a63e2ec97ed.svg";